import vue from 'vue'
import {apolloClient} from '@/graphql/apolloWrapper'
import {GET_SETTINGS_BY_SCOPE} from "../../graphql/queries/settings/fetchScope";
import {SETTINGS_CREATE} from "../../graphql/mutations/settings/create";
import {SETTINGS_UPDATE} from "../../graphql/mutations/settings/update";

const state = {
  scopes: []
};

const getters = {
  getSettingsByScope: (state) => (scope, scopeId) => state.scopes.find(settings => settings.scope === scope && settings.scope_id === scopeId),
};

const mutations = {
  UPDATE_SCOPED_SETTINGS (state, settings) {
    state.scopes.upsert({id: settings.id}, settings)
    console.log(state.scopes)
  }
};

const actions = {
  async settingsFetchByScope ({commit, state}, payload) {
    const {data} = await apolloClient.query({
      query: GET_SETTINGS_BY_SCOPE,
      variables: {scope: payload.scope, scopeId: payload.scope_id}
    });
    if (data && data.settingsFetchByScope) {
      commit('UPDATE_SCOPED_SETTINGS', data.settingsFetchByScope);
    }
  },
  async settingsCreate ({commit, state}, payload) {
    const {data} = await apolloClient.mutate({
      mutation: SETTINGS_CREATE,
      variables: {scope: payload.scope, scopeId: payload.scope_id}
    });

    if (data && data.settingsCreate) {
      commit('UPDATE_SCOPED_SETTINGS', data.settingsCreate);
    }
  },
  async settingsUpdate({dispatch, commit, state}, payload) {
    const {data} = await apolloClient.mutate({
      mutation: SETTINGS_UPDATE,
      variables: {id: payload.id, data: payload.data}
    });

    if (data && data.settingsUpdate) {
      commit('UPDATE_SCOPED_SETTINGS', data.settingsUpdate);
      dispatch('setSuccessMessages', 'Settings have been successfuly updated')
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js